import { Menu as BriqCommonMenu } from '@briq/shared'

export const Menu = BriqCommonMenu.Menu

export const MenuItem = BriqCommonMenu.MenuItem
